import { render, staticRenderFns } from "./wkButton.vue?vue&type=template&id=20833389"
import script from "./wkButton.vue?vue&type=script&lang=js"
export * from "./wkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports